import {
  DatabaseIcon,
  FileTextIcon,
  GlobeIcon,
  InfoIcon,
  ListTreeIcon,
  SearchIcon,
  SparklesIcon,
  TriangleAlertIcon,
  type LucideIcon,
} from "lucide-react";
import type { StepKind, TurnStep } from "../../../../shared/api.ts";

const ICONS: Record<StepKind, LucideIcon> = {
  reasoning: SparklesIcon,
  search: SearchIcon,
  read: GlobeIcon,
  tool: DatabaseIcon,
  tariff: ListTreeIcon,
  note: InfoIcon,
  warning: TriangleAlertIcon,
};

function isPdf(url: string | undefined): boolean {
  return Boolean(url && /\.pdf($|[?#])/i.test(url));
}

/** Icon by step kind; a read of a PDF, an uploaded file, or a stored source that is not a page shows a document. */
export function stepIcon(step: Pick<TurnStep, "kind" | "detail">): LucideIcon {
  const stored = step.detail?.tool === "read_evidence" && !step.detail.url;
  if (step.kind === "read" && (isPdf(step.detail?.url) || step.detail?.tool === "read_upload" || stored)) {
    return FileTextIcon;
  }
  return ICONS[step.kind];
}
